
import React from 'react';
import moment from 'moment'
import { Form, Button, Card, DatePicker, Input, Select, Radio, Checkbox, message, InputNumber } from 'antd';
import { addPreservation, getTypicalCasesBaseInfo, editPreservation } from '@/request/api'

const { Option } = Select;
let cYear = new Date().getFullYear();
let cMonth = new Date().getMonth() + 1;
let cDate = new Date().getDate();
class Patient extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // 防止保存按钮重复提交
      editBtn: true,
      addBtn: true,
      formRef: React.createRef(),
      inspectRef: React.createRef(),

      showDisabled: true,    // 表单置灰
      PreDisabled: false,    // 保存按钮
      addDisabled: false,    // 新建
      editDisabled: false,   // 修改
      status: 0,            // 提交状态
      isAll: false,          // 新建时清空
    }
  }

  componentDidMount() {
    this.allBasicData()
    const { form: { setFieldsValue } } = this.props;
    setFieldsValue({ "AGE_UNIT": "岁" }); //第一次进页面设置Radio的默认选中项为item 1
    this.setState({
      showDisabled: false, // 表单
      addDisabled: true,   // 新建
      editDisabled: true,  // 修改
      PreDisabled: false,  // 保存
      status: 1,
    })
  }


  componentDidUpdate(prevProps, prevState) {
    const newTableData = (this.props.tableData && this.props.tableData[0]) || {}
    const { NAME, BIRTHDAY, OUTP_NO, INP_NO, HEIGHT, CONTACT_TEL, SEX, AGE_UNIT, EXAM_AGE, CHARGE_TYPE, INSURANCE_TYPE, PATIENT_ID, WEIGHT, HOME_ADDRESS } = newTableData
    if (prevProps.tableData !== this.props.tableData) {
      this.setState({
        showDisabled: true,   // 表单
        addDisabled: false,   // 新建
        editDisabled: false,  // 修改
        PreDisabled: true,    // 保存可用
      })
      this.props.form.setFieldsValue({  // 在这传给父组件一个值
        NAME,
        BIRTHDAY: moment(BIRTHDAY),
        OUTP_NO,
        INP_NO,
        HEIGHT,
        CONTACT_TEL,
        SEX,
        EXAM_AGE,
        AGE_UNIT,
        CHARGE_TYPE,
        INSURANCE_TYPE,
        PATIENT_ID,
        WEIGHT,
        HOME_ADDRESS
      })
    }
  }


  handleAddSubmit = () => {
    const { tableData } = this.props
    if (this.state.isAll === true) {
      this.props.form.resetFields();
    }
    this.setState({
      showDisabled: false,   // 表单可用
      addDisabled: true,     // 新建不可用
      editDisabled: true,    // 修改不可用
      PreDisabled: false,    // 保存可用
      status: 1,
    })
    this.props.setAddSubmit(this.state.status)
    // 接收表格组件的值
    if (tableData) {
      this.setState({
        showDisabled: false,   // 表单可用
        addDisabled: true,     // 新建不可用
        editDisabled: true,    // 修改不可用
        PreDisabled: false,    // 保存可用
      })
    }
  }

  handleEditSubmit = (e) => {
    this.setState({
      showDisabled: false,   // 表单可用
      addDisabled: true,     // 新建不可用
      editDisabled: true,    // 修改不可用
      status: 2,     // 修改状态
    })
    const { tableData } = this.props
    if (tableData) {
      this.setState({
        showDisabled: false,   // 表单可用
        addDisabled: true,     // 新建不可用
        editDisabled: true,    // 修改不可用
        PreDisabled: false,    // 保存可用
      })
    }
  }

  handleCancel = (e) => {
    this.setState({
      addDisabled: false,    // 新建可用
      editDisabled: false,   // 修改可用
      PreDisabled: true,     // 保存按钮不可用
      showDisabled: true,    // 表单不可用
    })
  }

  handlePreserve = async (e) => { // 保存
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const { tableData, dataTime, itemName, itemCode, doctorCode, doctorName, examDeptCode, examDeptName, deptCode, deptName, examDoctorCode, examDoctorName, } = this.props
    e.preventDefault();
    // 防止重复提交
    if (this.state.addBtn) {
      this.setState({
        addBtn: false
      });

      const that = this;
      this.timerID = setTimeout(function () {
        that.setState({
          addBtn: true
        });
      }, 2000)
      // 提取InspectData组件的Form数据
      let inspectData = await this.props.getInspectData()
      if (this.state.status === 1) {
        this.props.form.validateFields((err, values) => {
          if (!err) {
            let params = {
              Type: "PATIENTADD",
              HOSPITAL_CODE: userInfo.HOSPITAL_CODE
            }
            let requestModel = {
              PATIENT_UID: tableData && tableData[0] && tableData[0].PATIENT_UID,
              AGE_UNIT: this.state.ageType || values.AGE_UNIT,
              NAME: values.NAME,
              BIRTHDAY: moment(values.BIRTHDAY).format('YYYY-MM-DD'),
              OUTP_NO: values.OUTP_NO,
              INP_NO: values.INP_NO,
              HEIGHT: values.HEIGHT,
              CONTACT_TEL: values.CONTACT_TEL,
              SEX: values.SEX,
              EXAM_AGE: values.EXAM_AGE,
              CHARGE_TYPE: values.CHARGE_TYPE,
              INSURANCE_TYPE: values.INSURANCE_TYPE,
              PATIENT_ID: values.PATIENT_ID,
              WEIGHT: values.WEIGHT,
              HOME_ADDRESS: values.HOME_ADDRESS,
              ACCESSIONNUMBER: inspectData.ACCESSIONNUMBER,
              ROOM_NO: inspectData.ROOM_NO,

              EXAM_DEPT_NAME: examDeptName,
              EXAM_DEPT_CODE: examDeptCode,

              ITEM_NAME: itemName,
              ITEM_CODE: itemCode,

              APPOINTMENT_TIME: dataTime,
              EXAM_NO: inspectData.EXAM_NO,
              BED_NO: inspectData.BED_NO,
              EXAM_SUB_CLASS: inspectData.EXAM_SUB_CLASS,
              EXAM_ROOM: inspectData.EXAM_ROOM,

              REQ_DEPT_NAME: deptName,
              REQ_DEPT_CODE: deptCode,

              CHARGES: inspectData.CHARGES || 0,
              PATIENT_SOURCE: inspectData.PATIENT_SOURCE,
              CLIN_DIAG: inspectData.CLIN_DIAG,

              EXAM_DOCTOR_NAME: examDoctorName,
              EXAM_DOCTOR_UID: examDoctorCode,

              CROWD_TYPE: inspectData.CROWD_TYPE,

              REQ_DOCTOR_NAME: inspectData.REQ_DOCTOR_NAME || doctorName,
              REQ_DOCTOR_CODE: inspectData.REQ_DOCTOR_CODE || doctorCode,

              EXAM_CLASS: inspectData.EXAM_CLASS
            }
            addPreservation(params, requestModel).then((res) => {
              if (res && res.Status === 1) {
                this.setState({
                  addDisabled: false,  // 新建可用
                  editDisabled: false, // 修改可用
                  PreDisabled: true,   // 保存置灰
                  showDisabled: true,  //表单置灰
                })
                message.success("新建成功！")
                this.props.clickApptQuery(); // 待预约
              } else {
                message.error("新建失败！")
              }
            })
          }
        });
      }
      if (this.state.status === 2) {
        var BIRTHDAY = tableData && tableData[0] && tableData[0].BIRTHDAY
        this.props.form.validateFields((err, values) => {
          if (!err) {
            let requestModel = {
              EXAM_UID: tableData && tableData[0] && tableData[0].EXAM_UID,
              PATIENT_UID: tableData && tableData[0] && tableData[0].PATIENT_UID,
              AGE_UNIT: this.state.ageType || values.AGE_UNIT,
              NAME: values.NAME,
              BIRTHDAY: moment(values.BIRTHDAY).format('YYYY-MM-DD') || BIRTHDAY,
              OUTP_NO: values.OUTP_NO,
              INP_NO: values.INP_NO,
              HEIGHT: values.HEIGHT,
              CONTACT_TEL: values.CONTACT_TEL,
              SEX: values.SEX,
              EXAM_AGE: values.EXAM_AGE,
              CHARGE_TYPE: values.CHARGE_TYPE,
              INSURANCE_TYPE: values.INSURANCE_TYPE,
              PATIENT_ID: values.PATIENT_ID,
              WEIGHT: values.WEIGHT,
              HOME_ADDRESS: values.HOME_ADDRESS,
              CROWD_TYPE: tableData && tableData[0] && tableData[0].CROWD_TYPE
            }
            editPreservation(requestModel).then((res) => {
              if (res && res.Status === 1) {
                message.success("修改成功!")
                // this.props.form.resetFields();
                this.props.clickApptQuery(); // 待预约
                this.props.clickAppoQuery(); // 预约
                this.props.clickRegQuery();  // 登记
              } else {
                message.error("修改失败!")
              }
            })
          }
        })
      }
    }
  }

  allBasicData = () => { // 费别、医保性质列表
    getTypicalCasesBaseInfo().then((res) => {
      if (res && res.Status === 1) {
        const basicsdata = res.Result.basicsdata
        Object.values(basicsdata).forEach((item) => {
          if (item.name === "费别") {
            this.setState({
              costType: item
            })
          }
          if (item.name === "医保性质") {
            this.setState({
              insuranceType: item
            })
          }
        })
      }
    })
  };

  // 只能选择今天跟今天之后的日期
  disabledDate = (current) => {
    return current && current > moment().endOf("day");
  }

  handleAgeChange = (e) => {
    this.setState({
      ageType: e
    })
  }

  // 是否手动清空表单
  changeCheckbox = (e) => {
    this.setState({ isAll: e.target.checked })
  }

  // 根据出生日期 计算年龄
  onChangeBirthday = (date, dateString, form) => {
    this.props.setBirthdayTime(dateString)
    let realAgeUnit = null;
    let realUnit = "岁";

    let realAgeMonth = null;
    if (new Date().getDate() >= date.format('DD')) {
      realAgeMonth = new Date().getMonth() + 1 - date.format('MM')
    } else {
      realAgeMonth = new Date().getMonth() - date.format('MM')
    }
    let realAge = parseInt(((new Date().getFullYear() - date.format('YYYY')) * 12 + realAgeMonth) / 12);  // 岁
    let realMonth = parseInt((new Date().getFullYear() - date.format('YYYY')) * 12 + realAgeMonth);  // 月

    if (realMonth < 1) {			// 小于一个月   天
      realAgeUnit = Math.floor((new Date().getTime() - new Date(dateString).getTime()) / 1000 / 3600 / 24);
      realUnit = "天";
    } else if (realMonth < 12) {			// 小于12个月 也就是小于一岁  月
      realAgeUnit = realMonth;
      realUnit = "月";
    } else {
      realAgeUnit = realAge;
      realUnit = "岁";
    }

    form.setFieldsValue({
      "EXAM_AGE": realAgeUnit,
      "AGE_UNIT": realUnit
    });
  }

  // 修改年龄 计算出生日期
  changeAge = (e, form) => {
    if (form.getFieldValue('AGE_UNIT') === "岁") {
      let a = cYear - e.target.value;
      form.setFieldsValue({
        "BIRTHDAY": moment(a + "-" + cMonth + "-" + cDate)
      });
    }

    if (form.getFieldValue('AGE_UNIT') === "月") {
      let a = null;
      let m = null;
      let b = cMonth - e.target.value;

      if (e.target.value <= 12) {
        if (b < 0) {
          a = cYear - 1;
          m = 12 + b;
        } else {
          a = cYear;
          m = b;
        }
        form.setFieldsValue({
          "BIRTHDAY": moment(a + "-" + m + "-" + cDate)
        });
      } else {					// 大于12个月
        let mon = parseInt(e.target.value / 12);
        let yu = parseInt(e.target.value % 12);
        let bb = cMonth - yu;

        if (bb <= 0) {
          a = cYear - 1 - mon;
          m = 12 + cMonth - yu;
        } else {
          a = cYear - mon;
          m = cMonth - yu;
        }
        form.setFieldsValue({
          "BIRTHDAY": moment(a + "-" + m + "-" + cDate).format()
        });
      }
    }

    if (form.getFieldValue('AGE_UNIT') === "天") {
      let m = new Date().getTime();
      let n = e.target.value * 24 * 3600 * 1000;
      form.setFieldsValue({
        "BIRTHDAY": moment(new Date(m - n))
      });
    }
  }

  // 修改年龄单位 计算出生日期
  handleChangeAgeUnit = (value, form) => {
    if (value === "岁") {
      let a = cYear - form.getFieldValue('EXAM_AGE');
      if (form.getFieldValue('EXAM_AGE')) {
        form.setFieldsValue({
          "BIRTHDAY": moment(a + "-" + cMonth + "-" + cDate)
        });
      }
    }

    if (value === "月") {
      let age = form.getFieldValue('EXAM_AGE');
      let a = null;
      let m = null;
      let b = cMonth - age;

      if (age <= 12) {
        if (b < 0) {
          a = cYear - 1;
          m = 12 + b;
        } else {
          a = cYear;
          m = b;
        }
        if (age) {
          form.setFieldsValue({
            "BIRTHDAY": moment(a + "-" + m + "-" + cDate)
          });
        }

      } else {
        let mon = parseInt(age / 12);
        let yu = parseInt(age % 12);
        let bb = cMonth - yu;

        if (bb <= 0) {
          a = cYear - 1 - mon;
          m = 12 + cMonth - yu;
        } else {
          a = cYear - mon;
          m = cMonth - yu;
        }
        if (age) {
          form.setFieldsValue({
            "BIRTHDAY": moment(a + "-" + m + "-" + cDate)
          });
        }
      }
    }

    if (value === "天") {
      let m = new Date().getTime();
      let n = form.getFieldValue('EXAM_AGE') * 24 * 3600 * 1000;
      if (form.getFieldValue('EXAM_AGE')) {
        form.setFieldsValue({
          "BIRTHDAY": moment(new Date(m - n))
        });
      }
    }
  }


  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { addDisabled, editDisabled, PreDisabled, showDisabled, status, costType, insuranceType } = this.state
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    return (
      <div>
        <Card size="small" className="followTitle doubleBox bord book" title={<p>病人信息</p>} >
          <Form {...formItemLayout} ref={this.formRef}>
            <div style={{ float: 'left', width: '50%' }}>
              <Form.Item label="姓名">
                {getFieldDecorator('NAME', {
                  rules: [{ required: true, message: '请输入您的姓名!' }],
                })(< Input disabled={showDisabled} />)}
              </Form.Item>
              <Form.Item label="出生日期">
                {getFieldDecorator('BIRTHDAY', { rules: [{ required: true, message: '请选择出生日期!' }] })(
                  <DatePicker
                    allowClear={false}
                    disabled={showDisabled}
                    onChange={(date, dateString) => this.onChangeBirthday(date, dateString, this.props.form)}
                    disabledDate={this.disabledDate}
                  />
                )}
              </Form.Item>
              <Form.Item label="门诊号">
                {getFieldDecorator('OUTP_NO')(<Input disabled={showDisabled} />)}
              </Form.Item>
              <Form.Item label="住院号">
                {getFieldDecorator('INP_NO')(<Input disabled={showDisabled} />)}
              </Form.Item>
              <Form.Item label="身高">
                {getFieldDecorator('HEIGHT', {
                })(<InputNumber min={1} max={250} disabled={showDisabled} />)}
                <span className="ant-form-text">cm</span>
              </Form.Item>
              <Form.Item label="电话">
                {getFieldDecorator('CONTACT_TEL', {
                  rules: [{ message: '请输入正确的手机号!', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/ }]
                })(<Input disabled={showDisabled} />)}
              </Form.Item>

              <div style={{ marginTop: '10px',marginLeft:'46px' }}>
                <Checkbox onChange={this.changeCheckbox}>新建时清空</Checkbox>
              </div>
            </div>
            <div style={{ float: 'left', width: '50%' }}>
              <Form.Item label="年龄">
                {getFieldDecorator('EXAM_AGE', { rules: [{ message: '年龄不能超过150且必须为整数!', pattern: /^[1][0-4][0-9]$|^[1-9]?[0-9]$|150/ }] })(
                  <Input min={1} max={150} disabled={showDisabled} onChange={(e) => this.changeAge(e, this.props.form)} addonAfter=
                    {getFieldDecorator('AGE_UNIT')(
                      <Select style={{ width: '60px' }} disabled={showDisabled} onChange={(value) => this.handleChangeAgeUnit(value, this.props.form)}>
                        <Option value="岁">岁</Option>
                        <Option value="月">月</Option>
                        <Option value="天">天</Option>
                      </Select>
                    )} />
                )}
              </Form.Item >
              <Form.Item label="性别">
                {getFieldDecorator('SEX', {
                  rules: [{ required: true, message: '请选择您的性别!' }],
                })(<Radio.Group disabled={showDisabled}>
                  <Radio value="M">男</Radio>
                  <Radio value="F">女</Radio>
                </Radio.Group>)}
              </Form.Item>
              <Form.Item label="费别">
                {getFieldDecorator('CHARGE_TYPE', {
                })(
                  <Select disabled={showDisabled} placeholder="请选择费别">
                    {
                      costType && costType.dt.map((item) => {
                        return <Option value={item.DIC_CODE} key={item.DIC_CODE}>{item.DIC_NAME}</Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="医保性质">
                {getFieldDecorator('INSURANCE_TYPE', {
                })(
                  <Select disabled={showDisabled} placeholder="请选择医保性质">
                    {
                      insuranceType && insuranceType.dt.map((item) => {
                        return <Option value={item.DIC_CODE} key={item.DIC_CODE}>{item.DIC_NAME}</Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="病历号">
                {getFieldDecorator('PATIENT_ID', {
                  rules: [{ required: true, message: '请输入您的病历号!' }],
                })(<Input disabled={showDisabled} />)}
              </Form.Item>
              <Form.Item label="体重">
                {getFieldDecorator('WEIGHT', {
                })(<InputNumber min={0} max={1000} disabled={showDisabled} />)}
                <span className="ant-form-text">kg</span>
              </Form.Item>
              <Form.Item label="地址">
                {getFieldDecorator('HOME_ADDRESS', {
                })(<Input disabled={showDisabled} />)}
              </Form.Item>
            </div>
            <div className="bookBtn" style={{ marginTop: "10px" }}>
              <Button type="primary">提取</Button>
              <Button type="primary" onClick={() => this.handleAddSubmit(status)} disabled={addDisabled}>新建</Button>
              <Button type="primary" onClick={() => this.handleEditSubmit(status)} disabled={editDisabled}>修改</Button>
              <Button type="primary" onClick={this.handlePreserve} disabled={PreDisabled}>保存</Button>
              <Button type="primary" onClick={this.handleCancel} disabled={PreDisabled}>取消</Button>
            </div>
          </Form>
        </Card>
      </div>
    )
  }
}

export default (Form.create({ name: 'hooks' })(Patient));
